import { useState } from "react";

import { PlaybackViewer } from "@/pages/UnitDetail/tabs/playback/PlaybackViewer";

interface Props {
  unitId: number;
}

function defaultWindow(): { start: string; end: string } {
  const end = new Date();
  const start = new Date(end.getTime() - 4 * 60 * 60 * 1000);
  return {
    start: trimSeconds(start),
    end: trimSeconds(end),
  };
}

function trimSeconds(d: Date): string {
  // ``datetime-local`` doesn't accept seconds in some browsers; trim.
  const pad = (n: number) => String(n).padStart(2, "0");
  return (
    d.getFullYear() +
    "-" +
    pad(d.getMonth() + 1) +
    "-" +
    pad(d.getDate()) +
    "T" +
    pad(d.getHours()) +
    ":" +
    pad(d.getMinutes())
  );
}

export function PlaybackTab({ unitId }: Props) {
  const [win, setWin] = useState(defaultWindow());

  return (
    <section className="space-y-3" data-testid="unit-playback-tab">
      <header className="flex flex-wrap items-end gap-2">
        <h2 className="text-sm font-semibold">Playback</h2>
        <div className="flex flex-wrap items-end gap-2 ml-auto">
          <label className="text-xs flex flex-col">
            <span className="text-muted-200">Desde</span>
            <input
              type="datetime-local"
              className="input"
              value={win.start}
              onChange={(e) => setWin({ ...win, start: e.target.value })}
            />
          </label>
          <label className="text-xs flex flex-col">
            <span className="text-muted-200">Hasta</span>
            <input
              type="datetime-local"
              className="input"
              value={win.end}
              onChange={(e) => setWin({ ...win, end: e.target.value })}
            />
          </label>
        </div>
      </header>

      <PlaybackViewer
        unitId={unitId}
        start={new Date(win.start).toISOString()}
        end={new Date(win.end).toISOString()}
      />
    </section>
  );
}
